import { Entity } from '../entity';
import { UUID } from '../uuid/entity';
import { type AssetTypeData } from './dto';

export class AssetType extends Entity {
    label: string;
    description: string;
    srcId?: string;
    isCustom: boolean;

    constructor({
        id,
        name,
        label,
        description,
        srcId,
        isCustom,
    }: {
        id: string;
        name?: string;
        label: string;
        description: string;
        srcId?: string;
        isCustom?: boolean;
    }) {
        super({ id, name });
        this.label = label;
        this.description = description;
        this.srcId = srcId;
        this.isCustom = isCustom ?? false;
    }

    static new({
        name,
        label,
        description,
        srcId,
        isCustom,
    }: Omit<AssetTypeData, 'id'>): AssetType {
        const uuid = new UUID();
        return new AssetType({
            id: uuid.toString(),
            name,
            label,
            description,
            srcId,
            isCustom,
        });
    }
}
